/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum PracticeNotebookSigningEnum {
	None = "None",
	Student = "Student",
	Tutor = "Tutor",
}

export function PracticeNotebookSigningEnumFromJSON(
	json: any
): PracticeNotebookSigningEnum {
	return PracticeNotebookSigningEnumFromJSONTyped(json, false);
}

export function PracticeNotebookSigningEnumFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): PracticeNotebookSigningEnum {
	return json as PracticeNotebookSigningEnum;
}

export function PracticeNotebookSigningEnumToJSON(
	value?: PracticeNotebookSigningEnum | null
): any {
	return value as any;
}
